// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","count":"DevModeKeyCount_count__4x3Ft"};